import { Card, Illustration, Text, Stack } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { CreateAPIKeyButton } from "./CreateAPIKeyButton";

interface Props {
  onOpenCreateAPIKeyModal: () => void;
}

export function Empty({ onOpenCreateAPIKeyModal }: Props) {
  return (
    <Card
      type="large"
      border="border-base"
      className={styles.wrapper}
      testID="empty-api-keys"
    >
      <Stack align="center" gap="space-4">
        <Illustration name="sparkles" />
        <Stack align="center" gap="space-3">
          <Text style="global/heading-medium" align="center" color="text-weak">
            <Trans>You have no API keys</Trans>
          </Text>
          <Text style="global/body-secondary" align="center" color="text-weak">
            <Trans>Once you've added an API key, it will appear here.</Trans>
          </Text>
          <CreateAPIKeyButton onPress={onOpenCreateAPIKeyModal} />
        </Stack>
      </Stack>
    </Card>
  );
}

const styles = {
  wrapper: css({
    padding: "var(--space-6) var(--space-4)",
  }),
};
